'use client';

import clsx from 'clsx';
import { useTranslations } from 'next-intl';
import { useState } from 'react';

import IconButton from '@commons/components/IconButton';
import MegaMenu from '@commons/components/PageLayout/Header/MegaMenu';
import { SearchInput } from '@commons/components/Search/Input';
import Text from '@commons/components/Text';
import BaseContainer from '@commons/containers/BaseContainer';
import Flex from '@commons/containers/Flex';

// Type definition for the SearchMenu component properties.

type Props = {
  className?: string;
};

/**
 * Desktop Search Menu.
 *
 * Displays a search icon with a MegaMenu on desktop.
 */

const SearchMenu = ({ className }: Props) => {
  const t = useTranslations('search');
  const [isOpen, setIsOpen] = useState(false);

  const toggleMenu = () => {
    setIsOpen((prev) => !prev);
  };

  const renderedTrigger = (
    <IconButton
      type={isOpen ? 'close' : 'search'}
      active={isOpen}
      colors={{ icon: 'black', bg: 'transparent' }}
      activeColors={{ icon: 'black', bg: 'grey-1' }}
      onClick={toggleMenu}
      className="nav_loop_icon"
      aria-label={t('menu')}
    />
  );

  const handleSearchSubmit = () => setIsOpen(false);

  const classes = clsx(isOpen && 'activeDesktopMenu', className);

  return (
    <MegaMenu
      theme="white"
      trigger={renderedTrigger}
      triggerMode="click"
      isOpen={isOpen}
      setIsOpen={setIsOpen}
      className={classes}
    >
      <Flex width={12} justify="center" paddingTop="xl">
        <BaseContainer width={{ xs: 10, lg: 8, xl: 6 }}>
          <Text as="h3" transform="uppercase" marginBottom="xl">
            {t('label')}
          </Text>
          <SearchInput onSearchSubmit={handleSearchSubmit} />
        </BaseContainer>
      </Flex>
    </MegaMenu>
  );
};
export default SearchMenu;
